<template>
    <main class="expert-modify-wrapper">
        <div class="inner">
            <h2 class="join-title">전자제조지원단 전문가 정보변경</h2>
            <nav class="join-step" style="margin-bottom:40px;">
                <ul class="join-step-lists">
                    <li :class="'list' + (isLogin ? ' list--on' : '')">
                        <span class="badge">1</span>
                        <span class="text">로그인</span>
                    </li>
                    <li :class="'list' + (isLogin ? '' : ' list--on')">
                        <span class="badge">2</span>
                        <span class="text">정보입력</span>
                    </li>
                </ul>
            </nav>
            <div class="expert-modify-inner-wrapper">
                <slot />
            </div>
        </div>
    </main>
</template>

<script>
export default {
    props: {
        isLogin: { type: Boolean, default: false },
    },
};
</script>

<style lang="scss" scoped>
.expert-modify-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    min-height: 100vh;
    padding: 50px 0;
}
</style>
